import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams } from "@angular/http";
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Actions } from "@ngrx/effects";
import { Observable } from "rxjs/Observable";
import { Store, Action } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Event } from "@models/event";
import { EventService } from "@services/event";
import { FETCH_EVENT, POPULATE_ACTIVE_EVENT } from "@reducers/events";
import { POPULATE_TEACHERS, FETCH_TEACHERS } from "@reducers/matrix-class";

@Injectable()
export class InternalEventViewResolver implements Resolve<boolean> {

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private eventService: EventService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const id: number = parseInt(route.params.id)
    const actionTypes: string[] = []

    actionTypes.push(POPULATE_TEACHERS)
    if (id) { actionTypes.push(POPULATE_ACTIVE_EVENT) }

    const result = this.actions
      .ofType(...actionTypes)
      .take(actionTypes.length)
      .skip(actionTypes.length - 1)
      .mapTo(true)

    if (id) { this.store.dispatch({ type: FETCH_EVENT, payload: id }) }
    this.store.dispatch({ type: FETCH_TEACHERS })

    return result
  }

}






// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/resolvers/internal-event-view.ts